import { TableHeader } from "./TableHeader";
import { TableItem } from "./TableItem";
import { TableItemsWrapper } from "./TableItemsWrapper";

import { TableRoot } from "./TableRoot";

export const Table = {
  Header: TableHeader,
  Item: TableItem,
  WrapperItems: TableItemsWrapper,
  Root: TableRoot,
};
